import React from 'react';
import { ChevronDownIcon, CalendarIcon } from 'lucide-react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useNavigate } from 'react-router-dom';
interface AcademicYear {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  isActive: boolean;
}
interface AcademicYearSelectorProps {
  years: AcademicYear[];
  selectedYearId: string;
  onYearChange: (yearId: string) => void;
  className?: string;
}
export const AcademicYearSelector: React.FC<AcademicYearSelectorProps> = ({
  years,
  selectedYearId,
  onYearChange,
  className = ''
}) => {
  const navigate = useNavigate();
  const selectedYear = years.find(y => y.id === selectedYearId) || years[0];
  return <DropdownMenu.Root data-id="element-42">
      <DropdownMenu.Trigger asChild data-id="element-43">
        <button className={`flex items-center gap-2 px-3 py-2 bg-white border border-custom rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium text-text-primary focus:outline-none focus:ring-2 focus:ring-[#00B75F] focus:ring-offset-1 ${className}`} data-id="element-44">
          <CalendarIcon size={16} className="text-text-secondary" data-id="element-45" />
          <span data-id="element-46">{selectedYear?.name}</span>
          {selectedYear?.isActive && <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-[#00B75F]/10 text-[#00B75F] uppercase tracking-wide" data-id="element-47">
              Active
            </span>}
          <ChevronDownIcon size={14} className="text-text-tertiary ml-1" data-id="element-48" />
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal data-id="element-49">
        <DropdownMenu.Content className="min-w-[200px] bg-white rounded-lg shadow-lg border border-custom p-1 z-50 animate-in fade-in zoom-in-95 duration-200" align="start" sideOffset={5} data-id="element-50">
          <DropdownMenu.Label className="px-2 py-1.5 text-xs font-semibold text-text-tertiary uppercase tracking-wider" data-id="element-51">
            Select Academic Year
          </DropdownMenu.Label>

          {years.map(year => <DropdownMenu.Item key={year.id} onClick={() => onYearChange(year.id)} className={`flex items-center justify-between px-2 py-2 rounded-md text-sm cursor-pointer outline-none transition-colors ${year.id === selectedYearId ? 'bg-[#00B75F]/10 text-[#00B75F] font-medium' : 'text-text-primary hover:bg-gray-50'}`} data-id="element-52">
              <span data-id="element-53">{year.name}</span>
              {year.isActive && <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-[#00B75F] text-white uppercase tracking-wide" data-id="element-54">
                  Active
                </span>}
            </DropdownMenu.Item>)}

          <DropdownMenu.Separator className="h-px bg-gray-100 my-1" data-id="element-55" />

          <DropdownMenu.Item onClick={() => navigate('/organization/settings')} className="px-2 py-2 text-xs text-text-secondary hover:text-[#00B75F] cursor-pointer hover:bg-gray-50 rounded-md transition-colors" data-id="element-56">
            Manage Academic Years...
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>;
};